import { ChevronDownIcon } from "@chakra-ui/icons";
import { Avatar, HStack, StackProps, Text, VStack } from "@chakra-ui/react";
import { useEffect } from "react";
import { useGetUserLoginStore } from "../../store/useGetUserLoginStore";
import { useUserHeader } from "../../store/useUserHeader";

interface Props extends StackProps {}

export const UserHeaderDrawer = ({ ...rest }: Props) => {
  const { userHeader, fetchUserHeader } = useUserHeader();
  const { currentActiveUser } = useGetUserLoginStore();

  useEffect(() => {
    if (!userHeader || currentActiveUser?.role !== userHeader?.role) {
      fetchUserHeader(currentActiveUser?.id, `${currentActiveUser?.role}`);
    }
  }, []);

  return (
    <>
      <HStack alignItems="center" py={3} mt={1} {...rest}>
        <Avatar
          name={userHeader?.name || ""}
          color={"white"}
          src={
            userHeader?.image
              ? `${process.env.REACT_APP_MEDIA_URL}${userHeader?.image}`
              : ""
          }
        />

        <VStack w={"100%"} gap={0} align={"stretch"}>
          <Text
            textStyle={"h-reg-title"}
            noOfLines={1}
            textOverflow={"ellipsis"}
          >
            {userHeader?.name}
          </Text>

          <Text textStyle={"b-reg"} variant={"secondary"}>
            Akun&nbsp;
            {userHeader?.role === "buyer"
              ? "Pembeli"
              : userHeader?.role === "supplier"
              ? "Supplier"
              : userHeader?.role === "reseller"
              ? "Reseller"
              : "BisnisLink"}
          </Text>
        </VStack>
      </HStack>

      <ChevronDownIcon boxSize={"28px"} />
    </>
  );
};
